import { useEffect, useRef } from 'react'
import { router } from '@inertiajs/react'
import consumer from '@/channels/consumer'

export function useBoardChannel(boardId: number, reloadOptions?: { only?: string[] }) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const reloadRef = useRef(reloadOptions)
  reloadRef.current = reloadOptions

  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: 'Tasks::BoardChannel', board_id: boardId },
      {
        received() {
          // Debounce: coalesce rapid updates into a single reload
          if (timerRef.current) clearTimeout(timerRef.current)
          timerRef.current = setTimeout(() => {
            router.reload(reloadRef.current ?? { only: ['tasks'] })
          }, 500)
        },
      }
    )

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      subscription.unsubscribe()
    }
  }, [boardId])
}
